import { useEffect } from 'react';
import { useIMask } from 'react-imask';
import type { FactoryOpts } from 'imask';
import { Input } from '@geely/ui';

interface MaskedInputProps {
  opts: FactoryOpts;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const PHONE_MASK_OPTS = {
  mask: [
    { mask: '(00) 0000-0000' },
    { mask: '(00) 00000-0000' },
  ],
  dispatch: (appended: string, dynamicMasked: { value: string; compiledMasks: FactoryOpts[] }) => {
    const digits = (dynamicMasked.value + appended).replace(/\D/g, '');
    return dynamicMasked.compiledMasks[digits.length > 10 ? 1 : 0];
  },
} as unknown as FactoryOpts;

export function MaskedInput({ opts, value, onChange, placeholder, className }: MaskedInputProps) {
  const { ref, setValue } = useIMask<HTMLInputElement>(
    opts,
    { onAccept: (maskedValue: string) => onChange(maskedValue) }
  );

  useEffect(() => {
    setValue(value || '');
  }, [value, setValue]);

  return (
    <Input
      ref={ref}
      placeholder={placeholder}
      className={className}
    />
  );
}
